import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import cookie from "js-cookie";
import { updateMeta } from "../../store/actions/metaAction";
import ReactQuill from "react-quill";
import { Container, Row, Col } from "reactstrap";

const FaqShow = ({ match }) => {
	const { control, register, handleSubmit, setValue } = useForm({
		defaultValues: {
			question: { ar: "", en: "" },
			answer: { ar: "", en: "" },
		},
	});

	const dispatch = useDispatch();
	const history = useHistory();

	const {
		params: { faqSlug },
	} = match;

	const quillModules = {
		toolbar: [
			[{ header: [1, 2, false] }],
			["bold", "italic", "underline", "strike"],
			[{ align: [] }],
			[{ list: "ordered" }, { list: "bullet" }],
			["blockquote", "code-block"],
			["link", "image", "video"],
			["clean"],
		],
	};

	const quillFormats = [
		"header",
		"bold",
		"italic",
		"underline",
		"strike",
		"align",
		"list",
		"blockquote",
		"code-block",
		"direction",
		"link",
		"image",
		"video",
	];

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل السؤال الشائع",
				breadcrumb: "الاسئلة الشائعة",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}pages/faqs/sections/${faqSlug}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(response => {
				const data = response.data.data.section;
				setValue("question.ar", data.question.ar);
				setValue("question.en", data.question.en);
				setValue("answer.ar", data.answer.ar);
				setValue("answer.en", data.answer.en);
			});
	};

	useEffect(() => {
		onStart();
	}, []);

	const onSubmit = data => {
		if (
			!data.question?.ar.trim() ||
			!data.question?.en.trim() ||
			!data.answer?.ar.trim() ||
			!data.answer?.en.trim()
		) {
			toast.error("يرجى ملء جميع الحقول باللغة العربية والإنجليزية");
			return;
		}

		axios
			.put(
				`${process.env.REACT_APP_API_URL}pages/faqs/sections/${faqSlug}`,
				{ section: data },
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(() => {
				toast.success("تم تحديث السؤال بنجاح");
				history.push("/faqs/index");
			})
			.catch(() => toast.error("حدث خطأ!"));
	};

	return (
		<section>
			<Container>
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="card">
						<div className="card-body">
							<Row style={{ marginTop: "2rem" }}>
								<Col md={6}>
									<div className="form-item">
										<label htmlFor="questionAr">السؤال بالعربية</label>
										<input
											id="questionAr"
											{...register("question.ar", { required: true })}
											className="form-control"
										/>
									</div>
								</Col>
								<Col md={6}>
									<div className="form-item">
										<label htmlFor="questionEn">السؤال بالإنجليزية</label>
										<input
											id="questionEn"
											{...register("question.en", { required: true })}
											className="form-control"
										/>
									</div>
								</Col>
							</Row>

							<Row>
								<Col md={6}>
									<div className="form-item">
										<label htmlFor="faqAR">الإجابة بالعربية</label>
										<Controller
											name="answer.ar"
											control={control}
											rules={{ required: true }}
											render={({ field }) => (
												<ReactQuill
													{...field}
													id="faqAR"
													theme="snow"
													modules={quillModules}
													formats={quillFormats}
												/>
											)}
										/>
									</div>
								</Col>
								<Col md={6}>
									<div className="form-item">
										<label htmlFor="faqEN">الإجابة بالإنجليزية</label>
										<Controller
											name="answer.en"
											control={control}
											rules={{ required: true }}
											render={({ field }) => (
												<ReactQuill
													{...field}
													id="faqEN"
													theme="snow"
													modules={quillModules}
													formats={quillFormats}
												/>
											)}
										/>
									</div>
								</Col>
							</Row>

							<Row>
								<Col>
									<div className="form-item mt-3">
										<button type="submit" className="bt bt-success btn-block">
											إرسال
										</button>
									</div>
								</Col>
							</Row>
						</div>
					</div>
				</form>
			</Container>
		</section>
	);
};

export default FaqShow;
